/*
 * @Author: lc 2631402207@qq.com
 * @Date: 2025-07-07 16:28:07
 * @LastEditors: lc 2631402207@qq.com
 * @LastEditTime: 2025-10-31 09:42:15
 * @FilePath: \ui\src\pages\RagPage\components\RagLandingView\index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import KBList, { KBButton } from '../KBList'
import { useConversationContext } from '../../../../stores/conversation.store'
import { MenuPage } from '../../../../stores/functionMenu.store'
import { useStyles } from '../../style'
import { useSearchParams } from 'react-router-dom'
import ChatInput from '../../../ChatPage/components/input'
import { RAGPlaceholderNode } from '../../../../const'
import ModelSelect from '@/pages/components/ModelSelect'

const RagLandingView = () => {
  const { styles } = useStyles()

  const [isLoading, setIsLoading] = useState(false)
  const navigate = useNavigate()
  const { createConversation } = useConversationContext()

  // 获取url参数
  const [searchParams, setSearchParams] = useSearchParams()
  const [inputContent, setInputContent] = useState(
    searchParams.get('key') || ''
  )
  const [selectedRag, setSelectedRag] = React.useState<string>(
    searchParams.get('rag') || 'HOPEInverter'
  )
  const [isSmallScreen, setIsSmallScreen] = useState(false)

  useEffect(() => {
    const checkScreenSize = () => {
      setIsSmallScreen(window.innerWidth < 1080)
    }

    checkScreenSize()
    window.addEventListener('resize', checkScreenSize)

    return () => {
      window.removeEventListener('resize', checkScreenSize)
    }
  }, [])
  const handleCreateConversation = (content: string) => {
    if (!content.trim() || isLoading) return

    setIsLoading(true)
    try {
      const newConversation = createConversation(MenuPage.Rag, content, {
        ragTag: selectedRag,
      })
      let params = new URLSearchParams()
      params.append('prompt', content)

      navigate(
        `/rag_chat/${newConversation.conversationId}?${params.toString()}`
      )
    } catch (error) {
      console.error('创建RAG对话错误:', error)
      setIsLoading(false)
    }
  }

  return (
    <div className={styles.container}>
      {!isSmallScreen && (
        <div className={styles.leftPanel}>
          <KBList selectedRag={selectedRag} setSelectedRag={setSelectedRag} />
        </div>
      )}

      <div
        className={styles.rightPanel}
        style={isSmallScreen ? { width: '100%' } : {}}
      >
        <div className={`${styles.card} ${styles.resultPanel}`}>
          {isSmallScreen && (
            <header className={styles.landingHeader}>
              <ModelSelect />
            </header>
          )}
          <RAGPlaceholderNode />
          {isSmallScreen && (
            <KBButton
              selectedRag={selectedRag}
              setSelectedRag={setSelectedRag}
            />
          )}
          <ChatInput
            inputValue={inputContent}
            onInputChange={setInputContent}
            onSubmit={handleCreateConversation}
            isLoading={isLoading}
            placeholder="您可以通过点击左侧变频器提问了解森兰知识库"
            isActionButton={true}
          />
        </div>
      </div>
    </div>
  )
}

export default RagLandingView
